import * as Yup from 'yup';
import i18n from 'i18n';

const schema = Yup.object().shape({
  username: Yup.string()
    .email(() => i18n.t('common:validation.emailInvalid'))
    .required(() => i18n.t('common:validation.fieldRequired')),
  password: Yup.string()
    .required(() => i18n.t('common:validation.fieldRequired')),
});

export default schema;
